import { createSlice } from "@reduxjs/toolkit";
 
const initialState = {
  currentPage: "default",
};
 
const ChatBotTemplatepageSlice = createSlice({
  name: "chatBotTemplatepage",
  initialState,
  reducers: {
    setChatBotTemplatePage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
});
 
export const { setChatBotTemplatePage } = ChatBotTemplatepageSlice.actions;
export default ChatBotTemplatepageSlice.reducer;

